import React from "react";
import { Form, Input } from "semantic-ui-react";

const LabeledInput = ({
  label,
  defaultValue,
  inline,
  icon,
  meta: { error, touched },
  ...props
}) => (
  <Form.Field inline={inline} defaultValue={defaultValue} error={error && touched}>
    <Input
      label={{ tag: true, content: label }}
      icon={icon}
      iconPosition="left"
      labelPosition="right"
      placeholder={props.placeholder}
      disabled={props.disabled}
      error={!!error}
      {...props}
    />
    {error && touched ? <span style={{ color: "red" }}>*{error}</span> : ""}
  </Form.Field>
);

export default LabeledInput;
